/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable multiline-ternary */
import './index.css';

import type {InputRef} from 'antd';
import {Button, Form, Input, Popconfirm, Table} from 'antd';
import type {FormInstance} from 'antd/es/form';
import React, {useContext, useEffect, useRef, useState} from 'react';

const EditableContext = React.createContext<FormInstance<any> | null>(null);

interface WatchProviderDTO {
  key?: React.Key;
  name: string;
  logo: string;
}
interface Item {
  name: string;
  logo: string;
}

interface EditableRowProps {
  index: number;
}

const EditableRow: React.FC<EditableRowProps> = ({ index, ...props }) => {
  const [form] = Form.useForm();
  return (
    <Form form={form} component={false}>
      <EditableContext.Provider value={form}>
        <tr {...props} />
      </EditableContext.Provider>
    </Form>
  );
};

interface EditableCellProps {
  title: React.ReactNode;
  editable: boolean;
  children: React.ReactNode;
  dataIndex: keyof Item;
  record: Item;
  handleSave: (record: Item) => void;
}

const EditableCell: React.FC<EditableCellProps> = ({
  title,
  editable,
  children,
  dataIndex,
  record,
  handleSave,
  ...restProps
}) => {
  const [editing, setEditing] = useState(false);
  const inputRef = useRef<InputRef>(null);
  const form = useContext(EditableContext)!;

  useEffect(() => {
    if (editing) {
      inputRef.current!.focus();
    }
  }, [editing]);

  const toggleEdit = () => {
    setEditing(!editing);
    form.setFieldsValue({ [dataIndex]: record[dataIndex] });
  };

  const save = async () => {
    try {
      const values = await form.validateFields();

      toggleEdit();
      handleSave({ ...record, ...values });
    } catch (errInfo) {
      console.log('Save failed:', errInfo);
    }
  };

  let childNode = children;

  if (editable) {
    childNode = editing
      ? (
        <Form.Item
          style={{ margin: 0 }}
          name={dataIndex}
        >
          <Input ref={inputRef} onPressEnter={save} onBlur={save} />
        </Form.Item>
      )
      : (
        <div className="editable-cell-value-wrap" style={{ paddingRight: 24 }} onClick={toggleEdit}>
          {children}
        </div>
      );
  }

  return <td {...restProps}>{childNode}</td>;
};

type EditableTableProps = Parameters<typeof Table>[0];

interface WatchProvidersProps{
  onWatchProvidersSubmit: (tableData) => void,
  watchProvidersRaw: WatchProviderDTO[],
  currentWatchProviders:  WatchProviderDTO[],
}

type ColumnTypes = Exclude<EditableTableProps['columns'], undefined>;

const WatchProvidersTableComponent: React.FC<WatchProvidersProps> = ({ currentWatchProviders, onWatchProvidersSubmit, watchProvidersRaw }) => {
  const [dataSource, setDataSource] = useState< WatchProviderDTO[]>(watchProvidersRaw || []);
  const [count, setCount] = useState(2);

  const handleDelete = (key: React.Key) => {
    console.log('key is', key);
    setDataSource(dataSource.filter((item) => item.key !== key));
    onWatchProvidersSubmit(dataSource.filter((item) => item.key !== key));
  };

  const defaultColumns: (ColumnTypes[number] & { editable?: boolean; dataIndex: string })[] = [
    {
      title: 'name',
      dataIndex: 'name',
      editable: true
    },
    {
      title: 'logo',
      dataIndex: 'logo',
      editable: true
    },
    {
      title: 'operation',
      dataIndex: 'operation',
      render: (_, record: { key: React.Key }) =>
        dataSource.length >= 1 ? (
          <Popconfirm title="Sure to delete this record?" onConfirm={() => handleDelete(record.key)}>
            <Button> Delete </Button>
          </Popconfirm>
        )
          : null
    }
  ];

  const handleProviderLogoClick = (providerButton) => {
    const newData: WatchProviderDTO = {
      key:  providerButton.name + Date.now(),
      name: providerButton.name,
      logo: providerButton.logo,

    };

    console.log("providerButton", newData);
    setDataSource([...dataSource, newData]);
    onWatchProvidersSubmit([...dataSource, newData]);
    setCount(count + 1);
  };

  const handleSave = (row: WatchProviderDTO) => {
    const newData = [...dataSource];
    const index = newData.findIndex((item) => row.key === item.key);
    const item = newData[index];
    newData.splice(index, 1, {...item, ...row    });
    onWatchProvidersSubmit(newData);
    setDataSource(newData);
  };

  const components = {
    body: {
      row: EditableRow,
      cell: EditableCell
    }
  };

  const columns = defaultColumns.map((col) => {
    if (!col.editable) {
      return col;
    }
    return {
      ...col,
      onCell: (record: WatchProviderDTO) => ({
        record,
        editable: col.editable,
        dataIndex: col.dataIndex,
        title: col.title,
        handleSave
      })
    };
  });


  console.log("dataSource", dataSource);

  return (
    <div>
      <div className={"watchProvidersContainer"} >{
        currentWatchProviders.map((i,j) =>
          <a onClick={() => handleProviderLogoClick(i)} className={"watchProviderButtonContainer"}>
            <img className='logo' key={j} alt={i.name} src={i.logo}/>
          </a>)
      }
      <a onClick={() => handleProviderLogoClick({key:Date.now(), name: "New", logo:""})} className={"watchProviderButtonContainer"}>
        <img className='logo' key={"j"} alt={"i.name"}  src='https://hoopt.s3.eu-west-1.amazonaws.com/static/black_logo.jpg'/>
      </a>
      </div>
      <Table
        size='small'
        components={components}
        rowClassName={() => 'editable-row'}
        bordered
        pagination={{position: ['bottomRight']}}
        dataSource={dataSource}
        columns={columns as ColumnTypes}
      />
    </div>
  );
};

export default WatchProvidersTableComponent;
